import Badge from "components/Badge/Badge";

export const generateResultBadgeHelper = (workItem) => {

  if (!workItem.status) {
    return <Badge color="warning">PROCESS PENDING</Badge>
  }

  return workItem.approved ? <Badge color="success">VALID</Badge> : <Badge color="danger">NOT VALID</Badge>;
}